import request from '@/utils/request'


export function addOrUpdatePanel(data) {
    return request({
        url: `api/serviceCenter/stainlessSteelSet/addOrUpdatePanel`,
        method: 'post',
        data,
    })
}


export function selectPanel(data) {
    // return request.get('http:9800//serviceCenter/test')
    return request({
        url: `api/serviceCenter/stainlessSteelSet/selectPanel?access=${data}`,
        method: 'post',
       // data,
    })
}


export function bathDeletePanelSet(data) {
    return request({
        url: `api/serviceCenter/stainlessSteelSet/bathDeletePanelSet`,
        method: 'post',
        data,
    })
}

export function selectStainlessCarvingName(data) {
    return request({
        url: `api/serviceCenter/stainlessSteelCarvingSet/selectStainlessCarvingName?access=${data}`,
        method: 'post',
    })
}

export function addOrUpdateStainlessFloor(data) {
    return request({
        url: `api/serviceCenter/stainlessSteelSet/addOrUpdateStainlessFloor`,
        method: 'post',
        data,
    })
}


export function selectStainlessFloor(data) {
    // return request.get('http:9800//serviceCenter/test')
    return request({
        url: `api/serviceCenter/stainlessSteelSet/selectStainlessFloor?access=${data}`,
        method: 'post',
       // data,
    })
}


export function bathDeleteStainlessFloor(data) {
    return request({
        url: `api/serviceCenter/stainlessSteelSet/bathDeleteStainlessFloor`,
        method: 'post',
        data,
    })
}


export function addOrUpdateStainlessSmall(data) {
    return request({
        url: `api/serviceCenter/stainlessSteelSet/addOrUpdateStainlessSmall`,
        method: 'post',
        data,
    })
}


export function selectStainlessSmall(data) {
    // return request.get('http:9800//serviceCenter/test')
    return request({
        url: `api/serviceCenter/stainlessSteelSet/selectStainlessSmall?access=${data}`,
        method: 'post',
       // data,
    })
}


export function bathDeleteStainlessSmall(data) {
    return request({
        url: `api/serviceCenter/stainlessSteelSet/bathDeleteStainlessSmall`,
        method: 'post',
        data,
    })
}

export function addOrUpdateStainlessSideband(data) {
    return request({
        url: `api/serviceCenter/stainlessSteelSet/addOrUpdateStainlessSideband`,
        method: 'post',
        data,
    })
}


export function selectStainlessSideband(data) {
    // return request.get('http:9800//serviceCenter/test')
    return request({
        url: `api/serviceCenter/stainlessSteelSet/selectStainlessSideband?access=${data}`,
        method: 'post',
       // data,
    })
}


export function bathDeleteStainlessSideband(data) {
    return request({
        url: `api/serviceCenter/stainlessSteelSet/bathDeleteStainlessSideband`,
        method: 'post',
        data,
    })
}
